import { Link } from "react-router-dom";
import { Web3Store } from "../../stores/web3Store";
import logo from "../../images/logo.png";
import {Menu, Tooltip} from "antd";
import "./index.less"
import { IRoute } from "../../bean/RouteBean";
import iconCard from "../../images/icons/zheng.png";
import iconCard1 from "../../images/icons/kapai.png";
import userIcon from "../../images/icons/user-center.png";
import nftBrandIcon from "../../images/icons/nft-brands.png";
import support from "../../images/icons/support.png";
import ipMarket from "../../images/icons/ip-market.png";
import React from "react";

const { Scrollbars } = require("react-custom-scrollbars");

interface IProps {
    web3Store: Web3Store;
    routes: IRoute[];
}

const SideMenu = ({ web3Store, routes }: IProps) => {
    const renderMenu = (routeList: IRoute[]) => {
        return routeList.map((route: IRoute, index: number) => {
            if (!route.children) {
                if (route.hidden) return "";
                else {
                    return <Menu.Item key={`item-${route.id}`}>{
                        route.isLink ?
                            route.isHref ? < a href={route.path} target={"_blank"} rel="noreferrer">
                                <MenuItem icon={route.meta ? route.meta.icon : ""}
                                    title={route.meta ? route.meta.title : ""} />
                            </a>
                                : <MenuItem icon={route.meta ? route.meta.icon : ""}
                                    title={route.meta ? route.meta.title : ""} />

                            :
                            <Link to={route.path}><MenuItem
                                icon={route.meta ? route.meta.icon : ""}
                                title={route.meta ? route.meta.title : ""} /></Link>
                    }</Menu.Item >
                }
            } else {
                return <Menu.SubMenu key={`sub-item-${route.id}`} icon={<MenuIcon icon={route.meta?.icon} />}
                    title={route.meta?.title}>
                    {renderMenu(route.children)}
                </Menu.SubMenu>
            }
        })
    }
    const contactList = [
        { name: "twitter", icon: "twitter", link: "https://twitter.com/MythNft" },
        { name: "discord", icon: "discord", link: "https://discord.gg/NQ3YudrRH4" },
        { name: "telegram", icon: "telegram", link: "https://t.me/SuperBrands" },
        { name: "medium", icon: "medium", link: "https://medium.com/@SuperBrands" },
        { name: "opensea", icon: "OpenSea-fill", link: "https://opensea.io/collection/myth-pass" },
        { name: "instagram", icon: "instagram-fill", link: "https://instagram.com/mythnft" },
    ]
    return <div className="side-menu">
        <Link to={'/licensing-market'} className="home-link"><img src={logo} className="logo" alt="SuperBrands logo" /></Link>
        <Scrollbars style={{ width: "100%", height: "calc(100vh - 64px)", borderRight: "1px solid #f5f5f5" }}>
            <Menu mode="inline" className="myth-menu">
                {renderMenu(routes)}
            </Menu>
            <div className="flex-row contact-list space-between">
                {contactList.map((item: any, index: number) => (
                    <Tooltip title={"soon"}key={"a-" + index}>
                    <div className={"contact-item"}><i
                        className={"iconfont icon-" + item.icon}></i><span
                            className="contact-name">{item.name}</span></div>
                    </Tooltip>
                        ))}
            </div>
        </Scrollbars>
    </div >
}

interface IPropsItem {
    icon?: string,
    title?: string
}

const MenuItem = ({ icon, title }: IPropsItem) => {
    return <><MenuIcon icon={icon} />
        {title && <span className="menu-name">{title}</span>}</>
}

const MenuIcon = ({ icon }: IPropsItem) => {
    let menuIcon;
    if (!icon) return <></>
    if (icon === "card") {
        menuIcon = <img className="menu-icon" src={iconCard} alt="" />;
    } else if (icon === "card1") {
        menuIcon = <img className="menu-icon" src={iconCard1} alt="" />;
    } else if (icon === "user-center") {
        menuIcon = <img className="menu-icon" src={userIcon} alt="" />;
    } else if (icon === "nft-brands") {
        menuIcon = <img className="menu-icon" src={nftBrandIcon} alt="" />;
    } else if (icon === "support") {
        menuIcon = <img className="menu-icon" src={support} alt="" />;
    } else if (icon === "Licensing-market") {
        menuIcon = <img className="menu-icon" src={ipMarket} alt="" />;
    } else {
        menuIcon = <i className={`iconfont icon-${icon}`}></i>
    }
    return menuIcon;
}
export default SideMenu;
